import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import theme from './theme';
import AnimatedHeader from './components/layout/AnimatedHeader';
import Dashboard from './components/features/Dashboard';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <AnimatedHeader />
          <Box sx={{ pt: { xs: 10, md: 12 } }}>
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/trending" element={<Dashboard />} />
                <Route path="/analytics" element={<Dashboard />} />
              </Routes>
            </AnimatePresence>
          </Box>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
